/* global axios */
import ApiClient from './ApiClient';

// The signed-in user's archived and pinned conversations (display ids).
class ZuwadConversationMarksAPI extends ApiClient {
  constructor() {
    super('zuwad_conversation_marks', {
      accountScoped: true,
      apiVersion: 'v2',
    });
  }

  // One of `archived` or `pinned` per call.
  patch({ conversationIds, archived, pinned }) {
    return axios.patch(this.url, {
      conversation_ids: conversationIds,
      archived,
      pinned,
    });
  }
}

export default new ZuwadConversationMarksAPI();
